import React, { useState } from 'react';
import {
  Button,
  TableCell,
  TableRow
} from '@material-ui/core';
import { convertUTCDateToLocalDate } from 'helpers/date';
import { format } from 'date-fns';
import ErrorDialog from './ErrorDialog';


const statusColors = {
  InProgress: '#103A99',
  Completed: '#008000',
  Failed: '#FF0000',
};

const LogTableRow = ({ syncLog }) => {
  const [isOpenDialog, setOpenDialog] = useState(false);

  const startedAt = convertUTCDateToLocalDate(syncLog.startedAt);
  const endedAt = syncLog.endedAt ? convertUTCDateToLocalDate(syncLog.endedAt) : '';
  const statusColor = statusColors[syncLog.status];

  return (
    <TableRow>
      <TableCell className="pl-sm-24 w-130 font-bold">
        {syncLog.eventName}
      </TableCell>
      <TableCell className="px-0 font-bold" align="center">
        {format(startedAt, 'MM/dd/yyyy hh:mm:ss aa')}
      </TableCell>
      <TableCell className="px-0 font-bold" align="center">
        {endedAt ? format(endedAt, 'MM/dd/yyyy hh:mm:ss aa') : ''}
      </TableCell>
      <TableCell className="px-0 font-bold" align="center" style={{color: statusColor}}>
        {syncLog.status}
      </TableCell>
      <TableCell className="px-0 font-bold" align="center">
        {syncLog.recordsUpdated}
      </TableCell>
      <TableCell className="px-0 font-bold w-100" align="center">
        {syncLog.error &&
          <Button
            variant="outlined"
            className="p-0"
            color="primary"
            onClick={() => setOpenDialog(true)}
          >
            ERROR
          </Button>
        }
      </TableCell>
      <ErrorDialog
        error={syncLog.error}
        isOpenDialog={isOpenDialog}
        setOpenDialog={setOpenDialog}
      />
    </TableRow>
  );
};

export default LogTableRow;
